import { render, staticRenderFns } from "./mailings_table.vue?vue&type=template&id=d93f4850&"
import script from "./mailings_table.vue?vue&type=script&lang=js&"
export * from "./mailings_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d93f4850')) {
      api.createRecord('d93f4850', component.options)
    } else {
      api.reload('d93f4850', component.options)
    }
    module.hot.accept("./mailings_table.vue?vue&type=template&id=d93f4850&", function () {
      api.rerender('d93f4850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mailings/mailings_table.vue"
export default component.exports